import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';

import ShipmentIcon from '@material-ui/icons/LocalShippingOutlined';

import CalloutBase from './Base';

const styles = () => ({
  shareSection: { backgroundColor: '#37A616' }
});

export const AutoTender = ({ t, printBOL, printLabels, sendDocs, classes }) => (
  <CalloutBase
    printBOL={printBOL}
    printLabels={printLabels}
    sendDocs={sendDocs}
    icon={ShipmentIcon}
    title={t('Your shipment is being tendered.')}
    message={t('This process can take up to one hour.')}
    classes={{ shareSection: classes.shareSection }}
  />
);

export default withStyles(styles)(withNamespaces()(AutoTender));
